import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { BACKUP_CODE_LENGTH, TOTP_CODE_LENGTH } from '../../pages/Mfa/Mfa';
import InputBox from '../InputBox/InputBox';
import './CodeInput.module.scss';

export const CodeInput = React.forwardRef(({ onChange, code, dataTestString, isSetupMode, codeLabel }, ref) => {
  const [showError, setShowError] = useState(false);
  const inputType = isSetupMode ? 'number' : 'text';
  return (
    <InputBox
      name="code"
      label={codeLabel}
      ref={ref}
      icon="locked"
      aria-label="code"
      onChange={onChange}
      onBlur={handleOnBlur}
      placeholder="6-digit-code"
      required
      type={inputType}
      dataTestString={dataTestString}
      value={code}
      autoFocus={!isSetupMode}
      errorMessage={showError ? 'Enter a valid code' : null}
    />
  );

  function handleOnBlur() {
    if (isSetupMode) {
      setShowError(code.length !== TOTP_CODE_LENGTH);
    } else {
      setShowError(code.length !== TOTP_CODE_LENGTH && code.length !== BACKUP_CODE_LENGTH);
    }
  }
});

CodeInput.defaultProps = {
  dataTestString: 'data-test-code-input',
};

CodeInput.propTypes = {
  onChange: PropTypes.func,
  code: PropTypes.string,
  dataTestString: PropTypes.string,
  isSetupMode: PropTypes.bool,
  codeLabel: PropTypes.string,
};
